<cfp-button
  [buttonStyle]="buttonStyle()"
  [buttonOutline]="buttonOutline()"
  [dataAnalytics]="dataAnalytics()"
  [classes]="'d-block d-lg-inline-block w-100 w-sm-auto'"
  (clicked)="download()"
  [dataTest]="'printButton'"
>
  @if (showIcon()) {
    <cfp-icon [icon]="icon()" [classes]="'me-2'" />
  }
  {{ buttonText() | translate }}
</cfp-button>
